import { PaletteThemeProps } from 'types/theme';
import { PaletteColorOptions, alpha } from '@mui/material/styles';
import { ThemeMode } from 'types/config';

const ThemeEfp = (mode: ThemeMode): PaletteThemeProps => {
    const isDark = mode === ThemeMode.DARK;

    const slate = {
        0: '#ffffff',
        50: '#fafafa',
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1',
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#314158',
        800: '#1e293b',
        900: '#0f172b',
    } as const;

    const darkBg = '#0b162a';
    const darkDeepBg = '#060b1d';

    const base = isDark
        ? {
              0: darkBg,
              50: '#121212',
              100: darkBg,
              200: slate[800],
              300: '#334155',
              400: slate[500],
              500: slate[400],
              600: slate[300],
              700: '#283550ff',
              800: darkBg,
              900: darkBg,
          }
        : { ...slate };

    const greyColors: PaletteColorOptions = {
        ...base,
        A50: isDark ? darkDeepBg : base[100],
        A100: base[0],
        A200: base[200],
        A400: base[400],
        A700: isDark ? slate[200] : slate[700],
        A800: isDark ? darkDeepBg : base[0],
    };

    const contrastText = '#fff';

    return {
        primary: {
            lighter: alpha('#2b7fff', 0.1),
            light: '#6db0ff',
            main: '#2b7fff',
            dark: '#1d4ed8',
            darker: isDark ? slate[200] : '#172554',
            contrastText: isDark ? slate[900] : slate[200],
        },
        secondary: {
            lighter: alpha('#00bba7', 0.1),
            main: '#00bba7',
            dark: '#0f766e',
            contrastText,
        },
        error: {
            lighter: alpha('#ef4444', 0.1),
            main: '#ef4444',
            dark: '#b91c1c',
            contrastText,
        },
        warning: {
            lighter: alpha('#f59e0b', 0.1),
            main: '#f59e0b',
            dark: '#b45309',
            contrastText: slate[700],
        },
        info: {
            lighter: alpha('#0ea5e9', 0.1),
            main: '#0ea5e9',
            dark: '#0369a1',
            contrastText,
        },
        success: {
            lighter: alpha('#10b981', 0.1),
            main: '#10b981',
            dark: '#047857',
            contrastText,
        },
        grey: greyColors,
    };
};

export default ThemeEfp;
